import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fold-expand" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"font-weight":"bold","font-size":"15px"} }
const _hoisted_5 = { style: {"font-weight":"bold","font-size":"15px"} }
const _hoisted_6 = { class: "second-item" }
const _hoisted_7 = { class: "item-inner" }
const _hoisted_8 = { class: "third-item" }
const _hoisted_9 = {
  class: "item-inner",
  style: {"padding-left":"20px"}
}

import '@/assets/font/iconfont.css'
import { ref } from "vue";
import { useStore } from 'vuex'
import {
    Document,
    Menu as IconMenu,
    Location,
    Setting,
} from "@element-plus/icons-vue";
import router from "../router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Nav',
  emits: ["changesCollapse", "changesJump"],
  setup(__props, { emit }) {


const store = useStore()
let isCollapse = ref(false);
const menulist = require(`../../public/json/allmenu.json`);

const allmenu = menulist.data;
const handleOpen = () => {
    isCollapse.value = false
    emit("changesCollapse", isCollapse.value);
};
const handleClose = () => {
    isCollapse.value = true
    emit("changesCollapse", isCollapse.value);
};
const jumpHandle = (item: any) => {
    router.push(item.path);
    emit("changesJump", item);
    store.commit('changeNavActive', item.menuID)
    localStorage.setItem('navActive', JSON.stringify(item));
};

return (_ctx: any,_cache: any) => {
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_Folder = _resolveComponent("Folder")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (!_unref(isCollapse))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 功能列表"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (!_unref(isCollapse))
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                onClick: handleClose
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Fold)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isCollapse))
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                onClick: handleOpen
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Expand)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_menu, {
      "default-active": _unref(store).state.navActive,
      class: "el-menu-vertical-demo",
      collapse: _unref(isCollapse),
      "background-color": "#F8F9FC"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allmenu), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.menuID
          }, [
            (!item.menuList)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  class: "first-item no-list-item",
                  onClick: ($event: any) => (jumpHandle(item)),
                  index: item.menuID
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Folder)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "index"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 1,
                  class: "first-item",
                  index: item.menuID
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Folder)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menuList, (i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: i.menuID
                      }, [
                        (!i.list)
                          ? (_openBlock(), _createBlock(_component_el_menu_item, {
                              key: 0,
                              index: i.menuID,
                              onClick: ($event: any) => (jumpHandle(i))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_el_icon, { style: {"padding-left":"10px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Document))
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(i.title), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["index", "onClick"]))
                          : _createCommentVNode("", true),
                        (i.list)
                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                              key: 1,
                              index: i.menuID
                            }, {
                              title: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Folder)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, _toDisplayString(i.title), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.list, (j) => {
                                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    index: j.menuID,
                                    onClick: ($event: any) => (jumpHandle(j)),
                                    key: j.menuID
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_el_icon, { style: {"padding-left":"10px"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Document))
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(j.title), 1)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["index", "onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "collapse"])
  ], 64))
}
}

})